<template>
    <div id="lonewolf-footer">
        <div class="logo-container">
            <img height="40" width="200" alt="Sellers Shield logo" :src="sellersShieldLogo"/>
        </div>
        <div style="text-align: center; background-color: #FFD700; font-weight: bold; margin-top: 25px;">
            The Gold Standard for Disclosures
        </div>
        <div class="lonewolf-footer-list" style="margin-top: 25px; text-align: left; max-width: 800px;">
            <div class="row">
                <div class="col-sm">
                    <h5 style="font-weight: bold;">Sellers Get:</h5>
                    <span><img :src="faCheckImage"> Educated on their risk</span><br><br>
                    <span><img :src="faCheckImage"> Guided trough the forms with expert tip and resources</span><br><br>
                    <span><img :src="faCheckImage"> Optional Home Sale Legal Protection&trade; </span><br><br>
                    <span><img :src="faCheckImage"> Prevent legal issues and save time </span><br><br>
                </div>
                <div class="col-sm">
                    <h5 style="font-weight: bold;">Agents Get:</h5>
                    <span><img :src="faCheckImage"> 100% complete PDFs, every time</span><br><br>
                    <span><img :src="faCheckImage"> Limited liability & proof of fiduciary duty</span><br><br>
                    <span><img :src="faCheckImage"> Happy and legally protected clients </span><br><br>
                    <span><img :src="faCheckImage"> Prevent legal issues and save time </span><br><br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './LonewolfFooter.scss';

export default {
    name: "LonewolfFooter",
    data: () => ({
        faCheckImage: require('@assets/images/font-awesome-check-circle.png'),
        sellersShieldLogo: require('@assets/images/SS-logo.png'),
    }),
}
</script>